import React from 'react';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import styles from './Projects.module.css';

const ProjectsErrorState = ({ error }) => {
  return (
    <div className={styles.container}>
      <div className={styles.errorState}>
        <HiOutlineExclamationTriangle className={styles.errorIcon} style={{
          width: '3rem',
          height: '3rem',
          color: 'var(--Red-600)',
          margin: '0 auto var(--spacing-s)'
        }} />
        <p className={styles.errorMessage}>{error}</p>
      </div>
    </div>
  );
};

export default ProjectsErrorState;